import { render } from "./TrackedDataFlowMarumiya.vue?vue&type=template&id=46ceefc8&scoped=true"
import script from "./TrackedDataFlowMarumiya.vue?vue&type=script&lang=ts"
export * from "./TrackedDataFlowMarumiya.vue?vue&type=script&lang=ts"

import "./TrackedDataFlowMarumiya.vue?vue&type=style&index=0&id=46ceefc8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46ceefc8"

export default script